export const OfficeApplianceSystemInfo = ({ applianceDetails }) => {
  //#region Data Display

  const display1stRow = [
    {
      label: "Created By:",
      value: applianceDetails?.createdBy,
    },
    {
      label: "Created Date:",
      value:
        applianceDetails?.createdDate &&
        new Date(applianceDetails?.createdDate).toLocaleDateString(),
    },
  ];

  const display2ndRow = [
    {
      label: "Modified By:",
      value: applianceDetails?.modifiedBy,
    },
    {
      label: "Modified Date:",
      value:
        applianceDetails?.modifiedDate &&
        new Date(applianceDetails?.modifiedDate).toLocaleDateString(),
    },
  ];
  //#endregion

  return (
    <div className="m-2 mt-4 bg-white rounded-lg box-shadow">
      <div className="text-quinary font-bold font-sans py-2 px-6">
        System Information
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 text-xs py-2">
        <div className="p-2 divide-y">
          {display1stRow.map((item, i) =>
            item ? (
              <DisplayRow key={i} label={item.label} value={item.value} />
            ) : null
          )}
        </div>
        <div className="p-2 divide-y">
          {display2ndRow.map((item, i) =>
            item ? (
              <DisplayRow key={i} label={item.label} value={item.value} />
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

const DisplayRow = ({ label, value }) => (
  <div className="grid grid-cols-3 p-2">
    <label className="fontExpand expandedLabel mx-4">{label}</label>
    <div className="col-span-2 expandedData fontExpand">
      <label>{value}</label>
    </div>
  </div>
);
